// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	jQ('.search-button').on('click', function() {
		setTimeout(function() {
			jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
			boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
		}, 500);
	});

	InstantSearch.prototype.beforeInit = function () {
    jQ('#search-results').attr("style", "display: none !important");
    if(Utils.isCollectionPage()) {
      jQ('.collection-filtering-section').hide();
    }
  };
  
  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;

    jQ('.site-nav--mobile .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-input-group input[type="search"]').focus();
      self.openSuggestionMobile();
      jQ('.drawer__close > button').trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;

    jQ('.site-header__links .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('#SearchContainer #search-input').focus();
      self.openSuggestionStyle3();
      jQ('.drawer__close > button').trigger('click');

    });
  }

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		this.prepareSuggestionProductPriceData();
    // console.log(this.data, 'Data prices');
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_max);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
      
      	var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
      	if (priceVaries) {
          	price = 'From ' + price;
        }
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
   }; 

})();
